module.exports = __webpack_public_path__ + "static/media/vedett-ipa.a689459f.jpg";